
export const LicensStatus = () => [
    {id: 0, status: "New", statusType: 0},
    {id: 1, status: "Processing", statusType: 1},
    {id: 2, status: "Rejected", statusType: 2},
    {id: 3, status: "Accepted", statusType: 3},
    {id: 4, status: "Paid", statusType: 4},
    {id: 5, status: "Cancelled", statusType: 5}
]

export const LicensStatusDanish = () => [
  {id: 0, status: "Modtaget", statusType: 0},
  {id: 1, status: "UnderBehandling", statusType: 1},
  {id: 2, status: "Afvist", statusType: 2},
  {id: 3, status: "Afventer betaling", statusType: 3},
  {id: 4, status: "Betalt/Aktiv/Udløbet", statusType: 4},
  {id: 5, status: "Annulleret", statusType: 5},
]

export const LicensStatusInvoicingDanish = () => [
  //{id: 0, status: "Modtaget", statusType: 0},
  //{id: 1, status: "UnderBehandling", statusType: 1},
  {id: 2, status: "Afvist", statusType: 2},
  {id: 3, status: "Afventer betaling", statusType: 3},
  {id: 4, status: "Betalt/Aktiv/Udløbet", statusType: 4},
  {id: 5, status: "Annulleret", statusType: 5},
]

export const ParkPeriod = () => [
    { id: 0, period: "1 dag",  periodType: 0, periodTime: 1, time: "1", price: "84.00"},
    { id: 1, period: "2 dage", periodType: 0, periodTime: 2, time: "2", price: "192.00"},
    { id: 2, period: "3 dage", periodType: 0, periodTime: 3, time: "3", price: "300.00"},
    { id: 3, period: "4 dage", periodType: 0, periodTime: 4, time: "4", price: "408.00"},
    { id: 4, period: "5 dage", periodType: 0, periodTime: 5, time: "5", price: "516.00"},
    { id: 5, period: "1 uge", periodType: 1, periodTime: 1, time: "7", price: "588.00"},
    //{ id: 6, period: "2 uger", periodType: 1, periodTime: 2, time: "14", price: "1176.00"},
    { id: 7, period: "1 mdr", periodType: 2, periodTime: 1, time: "1", price: "608.00"},
    { id: 8, period: "3 mdr", periodType: 2, periodTime: 3, time: "3", price: "1,824.00"},
    { id: 9, period: "6 mdr", periodType: 2, periodTime: 6, time: "6", price: "3,648.00"},
    { id: 10, period: "1 år", periodType: 3, periodTime: 1, time: "1", price: "7,296.00"},
    { id: 11, period: "Kommunale biler", periodType: 4, periodTime: 1, time: "1", price: "0.00"}
  ]

export const ParkArea = () => [
    { id: 0, area: "Alle betalingspladser i zone 2 og 3 (Frederiksø, P-Huset, Voldgade, Frederiksgade og Jessens Mole)"},
    { id: 1, area: "Frederiksø"},
  ]

  export const ParkCommuneArea = () => [
    { id: 0, area: "Voldgade og Rådhusgården"},
    { id: 1, area: "Zone 3 (Frederiksø og Voldgade)"},
    { id: 2, area: "Alle betalingspladser i zone 2 og 3 (Frederiksø, P-Huset, Voldgade, Frederiksgade og Jessens Mole)"},
    { id: 3, area: "Frederiksø"},
  ]

export const LicenseType = () => [
    { id: 0, LicenseType:  0, type: "Parkeringstilladelser"},
    { id: 1, LicenseType:  1, type: "Beboer- og erhvervslicens"},
    { id: 2, LicenseType:  2, type: "Håndværkerlicens"},
    { id: 3, LicenseType:  3, type: "Dispensationer"},

    // Events can be added here
    // { id: 4, LicenseType:  4, type: "Kørsels-/ parkeringstilladelse ved Landsstævnet 2022"}
  ]

export const LivingPeriod = () => [
    { id: 0, period: "1 år", periodType: 3, periodTime: 1, time: "1", price: "810.00"}
  ]

export const LivingArea = () => [
    { id: 0, area: "Område A"},
    { id: 1, area: "Område B"},
    { id: 2, area: "Område C"},
    { id: 3, area: "Område D"},
    { id: 4, area: "Område E"}
  ]

export const CraftmanPeriod = () => [
    { id: 0, period: "1 år", periodType: 3, periodTime: 1, time: "1", price: "414.00"},
    { id: 0, period: "1 år - Kommunale biler", periodType: 4, periodTime: 1, time: "1", price: "0.00"}
  ]

export const CraftmanArea = () => [
    { id: 0, area: "Betalingspladser samt tidsbegrænsede p-pladser med 1 time eller mere"},
  ]

export const DispensionPeriod = () => [
    { id: 0, period: "1 dag",  periodType: 0, periodTime: 1, time: "1", price: "0.00"},
    { id: 1, period: "2 dage",  periodType: 0, periodTime: 2, time: "2", price: "0.00"},
    { id: 2, period: "3 dage",  periodType: 0, periodTime: 3, time: "3", price: "0.00"},
    { id: 3, period: "4 dage",  periodType: 0, periodTime: 4, time: "4", price: "0.00"},
    { id: 4, period: "5 dage",  periodType: 0, periodTime: 5, time: "5", price: "0.00"},
    { id: 5, period: "1 uge",  periodType: 1, periodTime: 1, time: "7", price: "0.00"},
    { id: 6, period: "2 uger",  periodType: 1, periodTime: 2, time: "14", price: "0.00"},
    { id: 10, period: "1 år",  periodType: 3, periodTime: 1, time: "1", price: "0.00"},
  ]

export const DispensionArea = () => [
    { id: 0, area: "Kørselstilladelse Møllergade, Krøyersstræde, Klosterstræde"},
    { id: 1, area: "Kørselstilladese Torvet"},
    { id: 2, area: "Kørselstilladelse Gåsestræde"},
    { id: 3, area: "Arbejdskørsel og parkering - angiv sted i note"},
    { id: 4, area: "Af- og pålæsning - angiv sted i note"},
    { id: 5, area: "Parkering - angiv sted i note"},
    { id: 6, area: "Flytning - angiv sted i note"},
    { id: 7, area: "Andet - angiv i note"},
  ]

  export const ConventionPeriod = () => [
    { id: 0, period: "Mandag d. 27. juni", periodType: 1, periodTime: 1, dateType: "d", time: "1", price: "0.00"},
    { id: 1, period: "Tirsdag d. 28. juni", periodType: 2, periodTime: 1, dateType: "d", time: "1", price: "0.00"},
    { id: 2, period: "Onsdag d. 29. juni", periodType: 4, periodTime: 1, dateType: "d", time: "1", price: "0.00"},
    { id: 3, period: "Torsdag d. 30. juni", periodType: 8, periodTime: 1, dateType: "d", time: "1", price: "0.00"},
    { id: 4, period: "Fredag d. 1. juli", periodType: 16, periodTime: 1, dateType: "d", time: "1", price: "0.00"},
    { id: 5, period: "Lørdag d. 2. juli", periodType: 32, periodTime: 1, dateType: "d", time: "1", price: "0.00"},
    { id: 6, period: "Søndag d. 3. juli", periodType: 64, periodTime: 1, dateType: "d", time: "1", price: "0.00"},
    { id: 7, period: "Andet - angiv i note", periodType: 128, periodTime: 1, dateType: "d", time: "1", price: "0.00"},
  ]

  export const ConventionArea = () => [
    { id: 0, area: "Jessens Mole kl. 03:30 - 09:05"},
    { id: 1, area: "Jessens Mole med parkering på området kl. 03:30 - 09:05"},
    { id: 2, area: "Møllergade kl. 03:30 - 09:00"},
    { id: 3, area: "Møllergade med parkering på området kl. 03:30 - 09:00"},
    { id: 4, area: "Tinghusgade kl. 03:30 - 09:00"},
    { id: 5, area: "Tinghusgade med parkering på området kl. 03:30 - 09:00"},
    { id: 6, area: "Havnepladsen kl. 03:30 - 09:00"},
    { id: 7, area: "Havnepladsen med parkering på området kl. 03:30 - 09:00"},
    { id: 8, area: "Frederiksgade kl. 03:30 - 09:00"},
    { id: 9, area: "Frederiksgade med parkering på området kl. 03:30 - 09:00"},
    { id: 10, area: "Ryttervej kl. 00:00 - 24:00"},
    { id: 11, area: "Ryttervej med parkering på området kl. 00:00 - 24:00"},
    { id: 12, area: "Christiansminde kl. 00:00 - 24:00"},
    { id: 13, area: "Christiansminde med parkering på området kl. 00:00 - 24:00"},
    { id: 14, area: "Sofielund Skovvej kl. 00:00 - 24:00"},
    { id: 15, area: "Sofielund Skovvej med parkering på området kl. 00:00 - 24:00"},
    { id: 16, area: "Tipsvænget kl. 00:00 - 24:00"},
    { id: 17, area: "Tipsvænget med parkering på området kl. 00:00 - 24:00"},
    { id: 18, area: "Parkering uden for afspærringen kl. 00:00 - 24:00"},
    { id: 19, area: "Andet - angiv i note"},
  ]